import { Formik } from "formik";
import Eye from "../../form/Eye";
import { useState } from "react";
import Loader from "../../loader";
import ErrorMessage from "../../form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { registerFindAJobSchema } from "../../../utils/schema";
import { hireTalentSignUp } from "../../../redux/features/hire-talent/actions/authAction";

const RegisterStep = ({ backToLogin }) => {
  const dispatch = useDispatch();
  const [isEye1, setIsEye1] = useState(false);
  const [isEye2, setIsEye2] = useState(false);
  const { subLoading } = useSelector((state) => state.hireTalent?.auth);

  const savedData = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
  };
  const handleSignup = (values) => {
    const { confirm_password, ...rest } = values;

    const payload = Object.fromEntries(
      Object.entries(rest).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );

    const callback = (res) => {
      if (res?.success) {
        backToLogin();
      }
    };

    dispatch(hireTalentSignUp({ payload, callback }));
  };

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/hire_talent_signup.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0">
                    Hi! Find Work With
                    <span class="ct_yellow_text">Nuvio</span>
                  </h2>
                </div>
                <Formik
                  initialValues={savedData}
                  validationSchema={registerFindAJobSchema}
                  onSubmit={(values, actions) => {
                    handleSignup(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <form class="mt-5">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="mb-2 d-block ct_fs_14 ct_darkblue_text"
                            >
                              First Name
                            </label>
                            <input
                              type="text"
                              class="form-control ct_input"
                              placeholder="First Name"
                              id="first_name"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.first_name}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="first_name"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="mb-2 d-block ct_fs_14 ct_darkblue_text"
                            >
                              Last Name
                            </label>
                            <input
                              type="text"
                              class="form-control ct_input"
                              placeholder="Last Name"
                              id="last_name"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.last_name}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="last_name"
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="mb-2 d-block ct_fs_14 ct_darkblue_text"
                            >
                              Email
                            </label>
                            <input
                              type="text"
                              class="form-control ct_input"
                              placeholder="Email"
                              id="email"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.email}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="email"
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-3">
                            <label
                              for=""
                              class="mb-2 d-block ct_fs_14 ct_darkblue_text"
                            >
                              Password
                            </label>
                            <div class="position-relative">
                              <input
                                id="password"
                                class="form-control ct_input pe-5"
                                placeholder="Password"
                                type={isEye1 ? "text" : "password"}
                                value={values.password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <Eye isEye={isEye1} onClick={setIsEye1} />
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="password"
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-3">
                            <label
                              for=""
                              class="mb-2 d-block ct_fs_14 ct_darkblue_text"
                            >
                              Confirm Password
                            </label>
                            <div class="position-relative">
                              <input
                                id="confirm_password"
                                class="form-control ct_input pe-5"
                                placeholder="Confirm Password"
                                type={isEye2 ? "text" : "password"}
                                value={values.confirm_password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <Eye isEye={isEye2} onClick={setIsEye2} />
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="confirm_password"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="text-center mt-2">
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          class="ct_yellow_btn  w-100 mx-auto"
                        >
                          Sign Up
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
                <div class=" text-center mt-4 ct_darkblue_text">
                  Already have an account?{" "}
                  <a class="ct_orange_text" onClick={backToLogin}>
                    Sign In
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RegisterStep;
